import { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { PaymentsOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { createStripeCheckoutSession } from '../../../../../core/vendor-events/action';
import { PAYMENT_STATUS } from '../../../../../constants/event-application-status';
import { CustomButton } from '../../../../../components';

export default function PaymentPage() {
  const dispatch = useDispatch();
  const {
    events: { event },
    vendorEvents: { currentVendorEvent, vendorEventPayload, currentStripeSession },
  } = useSelector((store) => store);

  const calculateAmountToPay = (isFullPayment) => {
    if (currentVendorEvent?.status === PAYMENT_STATUS.BALANCE_DUE) {
      return currentVendorEvent.total_price - currentVendorEvent.total_amount_paid;
    }

    return isFullPayment ? currentVendorEvent.total_price : currentVendorEvent.total_price / 2;
  };

  const triggerCheckout = (isFullPayment) => {
    const { name, email } = currentVendorEvent.vendor;
    if (currentVendorEvent?.status !== PAYMENT_STATUS.PAID) {
      const payload = {
        vendor_info: {
          name,
          email,
          metadata: {
            vendorId: vendorEventPayload.fk_vendor,
          },
        },
        payment_info: {
          unit_amount: calculateAmountToPay(isFullPayment),
          currency: 'usd',
        },
        metadata: {
          eventId: vendorEventPayload.fk_event,
          vendorId: vendorEventPayload.fk_vendor,
          isFullPayment,
        },
      };
      dispatch(createStripeCheckoutSession(payload));
    }
  };

  const payFull = () => {
    triggerCheckout(true);
  };

  const payHalf = () => {
    triggerCheckout(false);
  };

  useEffect(() => {
    if (currentStripeSession?.id) {
      window.location.replace(currentStripeSession.url);
    }
  }, [currentStripeSession]);

  return (
    <Grid container spacing={4} paddingX={4}>
      <Grid item xs={12} display="flex" justifyContent="center" marginY={2}>
        <PaymentsOutlined />
        <Typography>You can now proceed with your payment</Typography>
      </Grid>

      <Grid item xs={12} display="flex" justifyContent="center" marginY={2}>
        <Grid container>
          <Grid item xs={12} display="flex" justifyContent="center" marginY={2}>
            <Typography>
              {currentVendorEvent.status === PAYMENT_STATUS.BALANCE_DUE
                ? `You have to complete your payment of $${currentVendorEvent.total_price} to confirm your spot.`
                : `You are about to pay $${currentVendorEvent.total_price} for the event ${event?.name}`}
            </Typography>
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="center" marginY={2}>
            <Typography>
              You will be redirected to the payment page to complete your payment.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} display="flex" justifyContent="center">
        <CustomButton variant="contained" onClick={payFull} sx={{ width: '50%' }}>
          Pay Balance
        </CustomButton>
      </Grid>
      {event?.allow_upfront_payment && currentVendorEvent.status === PAYMENT_STATUS.UNPAID && (
        <Grid item xs={12} display="flex" justifyContent="center">
          <CustomButton variant="contained" onClick={payHalf} sx={{ width: '50%' }}>
            Pay 50%
          </CustomButton>
        </Grid>
      )}
    </Grid>
  );
}
